import { render, staticRenderFns } from "./SectionLocalGov.vue?vue&type=template&id=19e9c9ec&scoped=true"
import script from "./SectionLocalGov.vue?vue&type=script&lang=ts"
export * from "./SectionLocalGov.vue?vue&type=script&lang=ts"
import style0 from "./SectionLocalGov.vue?vue&type=style&index=0&id=19e9c9ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e9c9ec",
  null
  
)

export default component.exports